import React, { useEffect, useRef } from 'react';
import { renderAsync } from 'docx-preview';
import './DocxViewer.css';

export const DocxViewer = ({ blob, onLoadError }) => {
    const containerRef = useRef(null);

    useEffect(() => {
        if (blob && containerRef.current) {
            renderAsync(blob, containerRef.current)
                .catch(error => {
                    console.error('DOCX render error:', error);
                    onLoadError?.('Не удалось отобразить DOCX файл');
                });
        }
    }, [blob, onLoadError]);

    return <div ref={containerRef} className="text-content-wrapper docx-viewer" />;
};